<mat-card appearance="outlined">
    <mat-card-content class="workbench-requirements-mat-card-content">
<workbench-notes-config #workbenchNotesConfig [client]="client" [account]="account"></workbench-notes-config>
<workbench-decision-config #workbenchDecisionConfig class="inner-page-section" [client]="client" [account]="account"></workbench-decision-config>
<workbenchv2-automated-mapping-config class="inner-page-section" [client]="client" [account]="account"></workbenchv2-automated-mapping-config>
<workbenchv2-task-options class="inner-page-section" [client]="client" [account]="account"></workbenchv2-task-options>
<workbenchv2-suppress-integrations-config class="inner-page-section" [account]="account"></workbenchv2-suppress-integrations-config>
    </mat-card-content>
</mat-card>
